<template>
  <v-container
    id="spareparts_archive"
    v-touch="{
      left: () => swipe('Left'),
      right: () => swipe('Right'),
    }"
    fluid
    tag="section"
    style="height: calc(100% - 110px)"
  >
    <base-material-card
      icon="mdi-eye-refresh"
      class="px-5 py-3"
      width="100%"
      title="Archivio Ordini Ricambi"
    >
      <!-- <v-row class="mt-4">
        <v-col
          cols="12"
        >
          <table
            v-if="cliente"
            class="text-h4 text-weigth-light"
          >
            <tr>
              <td class="text-no-wrap pr-3">
                Cliente
                <div v-if="isMobile">
                  {{ cliente.ragsoc }} {{ cliente.indiri_1 }}<br>
                  {{ cliente.indiri2 }} {{ cliente.locali }}
                </div>
              </td>
              <td v-if="!isMobile">
                {{ cliente.ragsoc }} {{ cliente.indiri_1 }}
              </td>
            </tr>
            <tr v-if="!isMobile">
              <td /><td>{{ cliente.indiri2 }} {{ cliente.locali }} </td>
            </tr>
          </table>
        </v-col>
      </v-row> -->
      <p class="mt-8 text-h4 text-weigth-light">
        Periodo:
      </p>
      <v-row
        no-gutters
        class="mt-6 justify-space-between"
      >
        <v-menu
          v-model="mnu_data_start"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$formatDate(data_start).substring(0, 10)"
              label="Data Inizio"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="data_start"
            locale="it-IT"
            @input="mnu_data_start = false"
          />
        </v-menu>
        <v-menu
          v-model="mnu_data_end"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="$formatDate(data_end).substring(0, 10)"
              label="Data Fine"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>
          <v-date-picker
            v-model="data_end"
            :allowed-dates="(val) => val >= data_start"
            locale="it-IT"
            @input="mnu_data_end = false"
          />
        </v-menu>
        <v-btn
          color="primary"
          @click="get_sparepartsOrders"
        >
          <v-icon>mdi-magnify</v-icon>
          Cerca
        </v-btn>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            v-if="listOrders"
            loading-text="Caricamento..."
            :loading="loading"
            :search="search"
            :items-per-page="-1"
            hide-default-footer
            :headers="headers"
            :items="listOrders"
            class="elevation-1"
            single-expand
            show-expand
            item-key="id"
            :expanded.sync="expanded"
          >
            <template v-slot:expanded-item="{ item }">
              <td
                width="100%"
                :colspan="headers.length +1"
                class="text-center pa-4"
              >
                <v-btn
                  class="float-right mt-1 mr-1"
                  text
                  x-small
                  @click="printTable"
                >
                  <v-icon small>
                    mdi-printer
                  </v-icon>
                </v-btn>
                <section class="stampoQuesto">
                  <div id="printable-table">
                    <v-data-table

                      :items-per-page="-1"
                      hide-default-footer
                      :headers="[
                        { text: 'Codice', value: 'codpar' },
                        { text: 'Codice Articolo', value: 'codart' },
                        { text: 'Descrizione', value: 'nomcom' },
                        { text: 'Colore', value: 'descol' },
                        { text: 'Quantita', value: 'qta' },

                      ]"
                      :items="JSON.parse(item.riga_ordine)"
                      class="elevation-1"
                    >
                      <template v-slot:item.descol="{item:riga}">
                        {{ riga.numcol }} {{ riga.descol }}
                      </template>
                    </v-data-table>
                  </div>
                </section>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>

    <v-overlay :value="loading">
      <v-row
        style="width:50vw; position:fixed; left:30vw"
      >
        <v-progress-circular
          indeterminate
          size="64"
        />
      </v-row>
    </v-overlay>
  </v-container>
</template>

<script>
  import Config from '@/config.js'

  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'SparepartsArchive',
    components: {

    },
    data () {
      return {
        loading: false,
        cliente: null,
        codcli: null,
        search: null,
        valid: true,
        listOrders: false,
        showBackOnline: false,
        mnu_data_start: false,
        data_start: new Date((Date.now() - (new Date()).getTimezoneOffset() * 60000) - (90 * 24 * 60 * 60 * 1000)).toISOString().substring(0, 10),
        mnu_data_end: false,
        data_end: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
        expanded: [],
        headers: [
          // { text: 'Progressivo', value: 'id' },
          { text: 'Data Ordine', value: 'created_at', align: 'left', width: '100%' },
          // { text: 'Note', value: 'WBOF_CODART' },
          // { text: 'Stato', value: 'emailed_at' },

        ],
      }
    },
    computed: {
      ...mapState(['auth', 'clidata']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },
      config () {
        return Config
      },
    },
    watch: {
      onLine (v) {
        if (v) {
          this.showBackOnline = true
          setTimeout(() => {
            this.showBackOnline = false
          }, 1000)
        }
      },
    },
    mounted () {
      window.addEventListener('online', this.updateOnlineStatus)
      window.addEventListener('offline', this.updateOnlineStatus)
      this.cliente = this.clidata.anacli
      var codsog = this.auth.userinfo.codsog
      var coddes = this.auth.userinfo.coddes.toString().padStart(3, '0')
      this.codcli = `${codsog}${coddes}`
      console.log('analisi codcli', this.codcli)
      this.get_sparepartsOrders()
    },
    beforeDestroy () {
      window.removeEventListener('online', this.updateOnlineStatus)
      window.removeEventListener('offline', this.updateOnlineStatus)
    },
    methods: {

      swipe (direction) {
        if (direction === 'Left') {
          this.step++
        } else {
          this.step--
        }
      },
      updateOnlineStatus (e) {
        const { type } = e
        this.onLine = type === 'online'
      },
      get_sparepartsOrders () {
        this.loading = true
        engine.get_sparepartsOrders(this.codcli, this.data_start, this.data_end)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })
              this.loading = false
              return
            }
            this.listOrders = result.data
          })
          .catch((errore) => {
            console.log('search err: ', errore)
          }).finally(() => { this.loading = false })
      },

      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      onSubmit () {
        this.valid = this.$refs.form.validate()
        // if (this.valid) {
        //   console.log('send', this.lens)
        //   const data = { lens: this.lens, cliente: this.cliente }
        //   engine.sendRiparazione(data).then((result) => {
        //     if (result) {
        //       // alert('Form has been submitted!')
        //       console.log('sendRiparazione', result)
        //       this.$store.commit('setSnack', { message: 'Inviato ordine di riparazione', color: '#4caf50', timeout: 5000 })
        //     }
        //   })
        //     .catch((errore) => {
        //       // eslint-disable-next-line no-console
        //       console.error('ERR####', errore)
        //     })
        //   return
        // }
        // this.$store.commit('setSnack', { message: 'Inserire Dati Obbligatori', color: '#c54747d4', timeout: 8000 })
        // this.$vuetify.goTo(0) // scroll top
        // console.log('send invadlid', this.lens)

        // engine.sendOrder(this.lens, this.page).then((result) => {
        //   if (result) {
        //     // alert('Form has been submitted!')
        //     console.log('update newitem', result)
        //     this.$emit('updateItem', result)
        //     this.$emit('close')
        //   }
        // })
        //   .catch((errore) => {
        //     // eslint-disable-next-line no-console
        //     console.error('ERR####', errore)
        //     this.$store.commit('setSnack', { message: 'General Error', color: '#c54747d4' })
        //   })
      },
      printTable () {
        // 1. Prendi l'elemento della tabella e il body
        const el = document.getElementById('printable-table')
        const body = document.body
        const app = document.getElementById('app') // L'id dell'app Vue

        // 2. Sposta la tabella fuori dall'app Vue (nel body) e nascondi l'app
        app.style.display = 'none'
        body.appendChild(el)

        // 3. Stampa
        window.print()

        // 4. Rimetti tutto a posto
        app.style.display = 'block'
        app.querySelector('.stampoQuesto').appendChild(el) // O dove si trovava prima
        // In alternativa, ricarica la pagina se è più semplice: location.reload();
      },
    },
  }

</script>
<style>
#riparazioni .bordered{
  border:1px solid #ccc;

}
@media print {
  @page {
    size: landscape;
    margin: 1cm;
  }

  /* Nascondi tutto ciò che è rimasto nel body tranne la nostra tabella */
  body > *:not(#printable-table) {
    display: none !important;
  }

  #printable-table {
    display: block !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    font-family: 'Roboto', sans-serif !important;
  }

  /* Forza i colori della tabella */
  .v-data-table {
    width: 100% !important;
  }

  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}

</style>
